import * as React from "react";
import { shallowEqual, useDispatch, useSelector } from "react-redux";
import classNames from "classnames";
import { Components, Logger, Services } from "@sendum/core";

import { VisibilityRootState } from "./store/VisibilityStore";
import * as VisibilityActions from "./store/VisibilityActions";
import { VisibilityGraphsTimeline } from "./components/VisibilityGraphsTimeline";
import { VisibilityMarkenSensors } from "./components/VisibilityMarkenSensors";
import { VisibilityHistoryTable } from "./components/VisibilityHistoryTable";

import classes from "./VisibilityMarken.module.scss";
import { AlarmOrMap } from "./components/AlarmOrMap/AlarmsOrMap";
import { Dewar } from "./components/Dewar/Dewar";
import { AnyAction } from "redux";
import { Landing } from './components/Landing'
import cn from './VisibilityMarken.module.scss'

const MAX_ACTIVE_SENSORS = 6;

// eslint-disable-next-line @typescript-eslint/no-unused-vars
const logger = new Logger("VisibilityMarkenShared");

export interface IProps {
	orderId?: string;
	deviceId?: string;
	openVirtualShipment?: (name: string) => void;
	openEndToEndShipment?: (orderId: string) => void;
	isLiveLegExtended?: boolean;
}

export const VisibilityMarkenShared = ({ orderId, openVirtualShipment, openEndToEndShipment, isLiveLegExtended }: IProps): JSX.Element => {
	logger.debug("render");
	const dispatch = useDispatch();
	const shipment = useSelector((state: VisibilityRootState) => state.Visibility.shipment, shallowEqual);
	const error = useSelector((state: VisibilityRootState) => state.Visibility.error, shallowEqual);
	const isLoadingShipment = useSelector((state: VisibilityRootState) => state.Visibility.isLoadingShipment);

	React.useEffect(() => {
		Services.MQTT.connect((message: string, topic: string): void => {
			dispatch(VisibilityActions.updateStateByMqtt(message, topic) as unknown as AnyAction);
		});

		return () => {
			dispatch(VisibilityActions.resetState() as unknown as AnyAction);
			Services.MQTT.disconnect();
		};
	}, [dispatch]);

	React.useEffect(() => {
		dispatch(VisibilityActions.resetState() as unknown as AnyAction);
		if (orderId) {
			dispatch(VisibilityActions.getShipmentShared(orderId, undefined, isLiveLegExtended) as unknown as AnyAction);
		}
	}, [dispatch, orderId, isLiveLegExtended]);

	if (!orderId && !shipment) {
		return (<Landing className={cn.landing} redirectPath='/visibility/shared'/>);
	}

	return (
		<div className={classes.visibility}>
			<Components.LoadingComponent loading={isLoadingShipment} className={classes.loading}/>
			{!!error && (<Components.ErrorComponent error={error}/>)}
			{shipment && !isLoadingShipment && !error && (
				<div className={classes.visibility__column}>
					<Dewar openVirtualShipment={openVirtualShipment} openEndToEndShipment={openEndToEndShipment}/>
					<div className={classes.visibility__sensors}><VisibilityMarkenSensors
						maxActiveSensors={MAX_ACTIVE_SENSORS}/></div>
					<div className={classNames(classes.visibility__map_and_graphs, classes.map_and_graphs)}>
						<div className={classes.map_and_graphs__row}>
							<div className={classes.map_and_graphs__graph}>
								<VisibilityGraphsTimeline maxSensors={MAX_ACTIVE_SENSORS}/>
							</div>
							<AlarmOrMap/>
						</div>
					</div>
					<div className={classes.visibility__history}>
						<VisibilityHistoryTable/>
					</div>
				</div>
			)}
		</div>
	);
};
